import { ChecklistItem, CoreKpi } from '../types';

export const getMaxOrderNum = (kpis?: CoreKpi[] | ChecklistItem[]) => {
  const kpisOrderNums = kpis?.map((k) => k?.order || 0);
  if (!kpisOrderNums?.length) return 0;

  return Math.max(...kpisOrderNums);
};
